import Icon from '@/components/ui/AppIcon';

interface VirtualConsultationProps {
  features: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
}

const VirtualConsultation = ({ features }: VirtualConsultationProps) => {
  return (
    <div className="bg-zinc-50 rounded-2xl p-6 md:p-8 border border-zinc-200">
      <div className="text-center mb-6 md:mb-8">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#1B5E4F] rounded-full mb-4">
          <Icon name="VideoCameraIcon" size={28} className="text-white md:hidden" />
          <Icon name="VideoCameraIcon" size={32} className="text-white hidden md:block" />
        </div>
        <h3 className="font-headline text-xl md:text-2xl font-normal text-black mb-2">
          Virtual Consultation Capabilities
        </h3>
        <p className="text-black/70 font-normal max-w-2xl mx-auto">
          Seamless remote collaboration for NRI families and long-distance clients
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl p-6 text-center border border-zinc-200 hover:border-zinc-300 hover:shadow-lg transition-all duration-300"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 bg-[#1B5E4F]/10 rounded-full mb-4">
              <Icon
                name={feature.icon as any}
                size={24}
                className="text-[#1B5E4F]"
              />
            </div>
            <h4 className="font-medium text-black mb-2">
              {feature.title}
            </h4>
            <p className="text-sm text-black/60 font-normal">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VirtualConsultation;